
import BaseTable from "@/components/BaseTable/index.vue";
import { Component, Vue } from "vue-property-decorator";
import {
  getHqNumberUnit,
  ProductNumberUnit,
  saveNumberUnit,
  searchProductNumberType,
} from "@/api/product-number";
import Pagination from "@/components/Pagination/index.vue";
import { Form } from "element-ui";
import ProductNumberUnitMove from "@/views-oms/product-business-management/product-hierarchy-management/number/unit/move.vue";

@Component({
  components: { ProductNumberUnitMove, Pagination, BaseTable },
})
export default class extends Vue {
  private sn = "";
  private productId = "";
  private productName = "";
  private numberId = "";
  private total = 0;
  private dialogVisible = false;
  private moveVisible = false;
  private pageParams = {
    number: "",
    numberTypeId: "",
    pageNumber: 1,
    pageSize: 10,
  };
  private moveModel = {
    productNumberId: "",
    type: "",
    typeNumber: "",
    number: "",
    productId: "",
    productName: "",
    typeId: "",
  };
  private saveParams = {
    typeId: "",
    typeNumber: "",
  };
  private numberTypeList = [];
  private cols = [
    {
      label: "编号类型",
      prop: "referenceType",
      key: "referenceType",
      type: String,
      width: "70",
    },
    {
      label: "编号",
      prop: "referenceNumber",
      key: "referenceNumber",
      type: String,
      width: "70",
    },
    // {
    //   label: "操作",
    //   prop: "actions",
    //   key: "actions",
    //   width: "70",
    //   type: "actions",
    //   options: [
    //     {
    //       name: "迁移至其他单元",
    //       click: "move",
    //       render: () => {
    //         return true;
    //       },
    //     },
    //   ],
    // },
  ];

  private saveRules = {
    typeId: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (value == null || value == "") {
            callback(new Error("请选择编号类型"));
          } else {
            callback();
          }
        },
        trigger: "blur",
      },
    ],
    typeNumber: [
      { required: true, message: "请输入编号", trigger: "blur" },
      { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" },
    ],
  };
  private data = [] as ProductNumberUnit[];

  mounted() {
    this.numberId = this.$router.currentRoute.query.id as any;
    this.productName = this.$router.currentRoute.query.name as any;
    this.productId = this.$router.currentRoute.query.productId as any;
    this.sn = this.$router.currentRoute.query.sn as any;

    this.getList();
    this.getTypeList();
  }

  private cancel() {
    this.moveVisible = false;
    this.getList();
  }

  private async getTypeList() {
    await searchProductNumberType().then((res) => {
      this.numberTypeList = res as any;
    });
  }
  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    await getHqNumberUnit(this.numberId, this.pageParams).then((res) => {
      let pageable = res as any;
      this.data = pageable.list as ProductNumberUnit[];
      this.total = Number.parseInt(pageable.total);
    });
    this.loading = false;
  }

  private add() {
    this.dialogVisible = true;
    this.getTypeList();
  }

  private async save() {
    let dataForm = this.$refs.saveForm as Form;
    dataForm.validate(async (valid) => {
      if (valid) {
        saveNumberUnit(this.numberId, this.saveParams).then(() => {
          this.handleClose();
        });
        return true;
      }
      return false;
    });
  }

  private move(scoop) {
    this.moveModel.productNumberId = this.numberId;
    this.moveModel.type = scoop.row.referenceType;
    this.moveModel.typeNumber = scoop.row.referenceNumber;
    this.moveModel.number = this.sn;
    this.moveModel.productId = this.productId;
    this.moveModel.productName = this.productName;
    this.moveModel.typeId = scoop.row.referenceTypeId;
    this.moveVisible = true;
  }

  private handleClose() {
    this.saveParams = {} as any;
    this.dialogVisible = false;
    this.getList();
  }

  private resetQuery() {
    this.pageParams = {
      number: "",
      numberTypeId: "",
      pageNumber: 1,
      pageSize: 10,
    };
  }
}
